module.exports = __webpack_public_path__ + "static/media/close-red.726a116e.svg";